
import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";

import { RootState } from "../store";
import { AccountState } from "../../types/account.types";
import { ICreds } from "../../types/login.types";


export const setIsAccountLogedIn = createAsyncThunk(
  'account/setIsAccountLogedIn',
  async (isLoggedIn: boolean, { getState, dispatch }) => {
    const state = getState() as RootState;
    clearInterval((state.login as ICreds).pollingIntervalId);
    return isLoggedIn;
  }
);


const initialState: AccountState = {
  isAccountLoggedIn: false,
  details: {}
};

const accountSlice = createSlice({
  name: "startup",
  initialState: initialState,
  reducers: {
    setAccountDetails: (state, action) => {
      return { ...state, details: { ...action.payload } };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(setIsAccountLogedIn.fulfilled, (state, action) => {
      state.isAccountLoggedIn = action.payload;
    });
  },

});

export const isAccountLoggedIn = (state: RootState) => state.account.isAccountLoggedIn;
export const getAccountDetails = (state: RootState) => state.account.details;
export const { setAccountDetails } = accountSlice.actions



export default accountSlice.reducer;
